declare var angular: any;
declare var hello: any;

import * as Msal from 'msal';
import * as moment from 'moment';

const msalConfig: any = {
  auth: {
    clientId: 'f9388ed2-8000-484e-aabc-f5fa07a98c59',
    // authority: "common",
    redirectUri: window.location.href.split('?')[0]
  },
  cache: {
    cacheLocation: 'sessionStorage' // This configures where your cache will be stored
  }
};

angular
  .module('GlobalControllers')

  .controller('LoginCtrl', [
    '$location',
    '$scope',
    'api',
    'navbar',
    '$mdToast',
    '$window',
    '$routeParams',
    'EXAM',
    'exam',
    async function(
      $location,
      $scope,
      api,
      navbar,
      $mdToast,
      $window,
      $routeParams,
      EXAM,
      exam
    ) {
      let dd = {
        toeic: {
          t: `${exam.examData.numberOfExams *
            exam.examData
              .numberOfQuestionsPerExam} questions TOEIC® Listening & Reading`
        },
        linguaskill: {
          t: `${exam.examData.numberOfExams *
            exam.examData.numberOfQuestionsPerExam} questions`
        }
      };
      $scope.data = {};
      $scope.years = [];

      $scope.limitedOffer = EXAM === 'toeic' ? 4 : 3;

      $scope.offers = [
        {
          title: 'Découverte',
          items: [
            'Tableau de bord',
            dd[EXAM]?.t,
            "3 modes d'entrainements",
            'Corrigés détaillés',
            EXAM === 'toeic' ? 'Tips sur les 7 parties du test' : null,
            `${exam.examData.numberOfExams} tests blancs`,
            'Cours de grammaire / conjugaison / vocabulaire'
          ].filter(r => !!r)
        },
        {
          title: 'Candidat',
          items: [
            'Tableau de bord',
            dd[EXAM]?.t,
            "3 modes d'entrainements",
            'Corrigés détaillés',
            EXAM === 'toeic' ? 'Tips sur les 7 parties du test' : null,
            `${exam.examData.numberOfExams} tests blancs`,
            'Cours de grammaire / conjugaison / vocabulaire'
          ].filter(r => !!r)
        }
      ];

      $scope.selectedPrice = {
        value: 1
      };

      var getOptions = $location.search();

      if (getOptions['plan']) {
        var plan = getOptions['plan'];
        var pPlan = {
          15: 0,
          31: 1,
          92: 2
        };
        $scope.selectedPrice.value = pPlan[plan];
      }

      if (getOptions.org) {
        let orgSlug = getOptions.org;

        let org = await api.getOrgBySlug(orgSlug);
        if (org) {
          $scope.org = org;
        }
      }

      $scope.reset = function(index) {
        if (index === 0 && !$scope.activation && $scope.register) {
          $scope.choosePlan = null;
        }
      };

      $scope.onSelectedPriceChange = function() {
        console.log('y', $scope.selectedPrice.value);
        if ($scope.selectedPrice.value === 1) {
          $scope.planValue = 31;
          $scope.price = 59;
        } else if ($scope.selectedPrice.value === 0) {
          $scope.planValue = 15;
          $scope.price = 39;
        } else if ($scope.selectedPrice.value === 2) {
          $scope.planValue = 92;
          $scope.price = 79;
        }
      };
      $scope.onSelectedPriceChange();

      $scope.selectPlan = function(isFree) {
        if (isFree) {
          $scope.choosePlan = 'free';
        } else {
          $scope.choosePlan = $scope.planValue;
        }
      };

      var years = [];
      for (var i = 1930; i < 2017; i++) {
        years.push(i);
      }
      $scope.years = years.reverse();

      var getOptions = $location.search();
      if (getOptions['plan']) {
        $scope.choosePlan = getOptions['plan'];
      }

      var path = $location.path();

      if ($scope.main.me) {
        if (path === '/activation') {
        } else {
          $location.url('/');
        }
      }

      if (path === '/register') {
        $scope.steps = new Array(3);
        $scope.register = true;
      } else if (path === '/activation') {
        $scope.steps = new Array(2);
        navbar.goBackAction('Activation de votre code', '#!/');
        $scope.register = true;
        $scope.activation = true;
      } else {
        $scope.register = false;
      }

      $scope.data.username = $location.search().username;

      $scope.login_microsoft = function() {
        // Add here scopes for id token to be used at MS Identity Platform endpoints.
        const loginRequest = {
          scopes: ['openid', 'email']
        };

        const myMSALObj = new Msal.UserAgentApplication(msalConfig);
        function signIn() {
          $scope.loading = true;
          myMSALObj
            .loginPopup(loginRequest)
            .then(loginResponse => {
              console.log('id_token acquired at: ' + new Date().toString());
              console.log('loginResponse', loginResponse);

              getTokenPopup(loginRequest).then(async response => {
                console.log('response token', response);

                api.microsoftAuth((response as any).idToken.rawIdToken).then(
                  function(response) {
                    api.me().then(function() {
                      $scope.loading = false;
                      redirectAfterLogin();
                    });
                  },
                  function(response) {
                    $scope.loading = false;
                    $scope.error =
                      response.data.title + ' - ' + response.data.description;
                  }
                );
              });
            })
            .catch(error => {
              console.log(error);

              $scope.loading = false;
              $scope.error = error;
            });
        }

        function getTokenPopup(request) {
          return myMSALObj.acquireTokenSilent(request).catch(error => {
            console.log(error);
            console.log(
              'silent token acquisition fails. acquiring token using popup'
            );

            // fallback to interaction when silent call fails
            return myMSALObj
              .acquireTokenPopup(request)
              .then(tokenResponse => {
                return tokenResponse;
              })
              .catch(error => {
                console.log(error);
              });
          });
        }

        signIn();
      };

      $scope.login_fb = function() {
        $scope.loading = true;
        hello('facebook')
          .login()
          .then(
            function(response) {
              api.facebookAuth(response.authResponse.access_token).then(
                function(response) {
                  api.me().then(function() {
                    $scope.loading = false;
                    redirectAfterLogin();
                  });
                },
                function(response) {
                  $scope.loading = false;
                  $scope.error =
                    response.data.title + ' - ' + response.data.description;
                }
              );
            },
            function(e) {
              $scope.loading = false;
              $scope.error = e.error.message;
            }
          );
      };

      $scope.login_google = function() {
        $scope.loading = true;
        hello('google')
          .login()
          .then(
            function(response) {
              console.log('resp', response);
              api.googleAuth(response.authResponse.access_token).then(
                function(response) {
                  api.me().then(function() {
                    $scope.loading = false;
                    redirectAfterLogin();
                  });
                },
                function(response) {
                  $scope.loading = false;
                  $scope.error =
                    response.data.title + ' - ' + response.data.description;
                }
              );
            },
            function(e) {
              $scope.loading = false;
              $scope.error = e.error.message;
            }
          );
      };

      $scope.submit_register = function() {
        $scope.loading = true;
        $scope.error = null;

        api.register($scope.data).then(
          function(data) {
            api.me().then(function() {
              $scope.loading = false;
              var referral = localStorage.getItem('referral');
              if (referral) {
                api.updateReferralByUserId(referral);
              }
              redirectAfterLogin();
            });
          },
          function(response) {
            $scope.loading = false;
            handleError(response.data.title, response.data.description);
          }
        );
      };

      $scope.submit_login = function() {
        $scope.loading = true;
        $scope.error = null;

        api.login($scope.data.username, $scope.data.password).then(
          function(response) {
            api.me().then(function() {
              $scope.loading = false;
              redirectAfterLogin();
            });
          },
          function(response) {
            $scope.loading = false;
            handleError(response.data.title, response.data.description);
          }
        );
      };

      function handleError(title, description) {
        if (title === 'User already exists') {
          $scope.error = 'Ce compte existe déjà';
        } else if (title === 'Invalid credentials') {
          $scope.error = 'Combinaison adresse email/mot de passe incorrecte';
        } else {
          $scope.error = title + ' - ' + description;
        }
      }

      function redirectAfterLogin() {
        if ($scope.register) {
          $window.localStorage.dateOfRegister = JSON.stringify(
            moment.utc().toISOString()
          );
        }

        if (path === '/activation') {
          // $location.url('/');
        } else if (!!$scope.choosePlan) {
          if ($scope.choosePlan !== 'free') {
            console.log('yyy', '/payment/form?plan=' + $scope.choosePlan);
            $location.url('/payment/form?plan=' + $scope.choosePlan);
          } else {
            $location.url('/');
          }
        } else {
          $location.url('/');
        }
      }

      // activation
      $scope.dataActivation = {};

      $scope.activate_promocode = function() {
        api.activatePromocode($scope.dataActivation.code).then(
          function(res) {
            delete $window.localStorage.dateOfRegister;
            console.log('res', res);
            $mdToast.show(
              $mdToast
                .simple()
                .textContent(res.message)
                .position('bottom right')
            );
            setTimeout(function() {
              $location.url('/');
            }, 200);
          },
          function(res) {
            console.log('data', res.data);
            $scope.error = res.data.message;
            $mdToast.show(
              $mdToast
                .simple()
                .textContent(res.data.message)
                .position('bottom right')
            );
          }
        );
      };

      $scope.setActivationType = function(activationType) {
        $scope.activationType = activationType;
      };

      $scope.resetActivationType = function() {
        $scope.activationType = null;
      };

      let loginProvider = $routeParams.loginProvider;
      let availableLoginProviders = ['microsoft', 'google'];
      if (window.location.href.includes('sso')) {
        api
          .me()
          .then(function(res) {
            $scope.loading = false;
            redirectAfterLogin();
          })
          .catch(err => {
            console.log('err', err);
            if (availableLoginProviders.includes(loginProvider)) {
              if (loginProvider === 'microsoft') {
                $scope.socialLoginProviders = 'microsoft';
              } else {
                $location.url('/');
              }
            }
          });
      }

      $scope.socialProviders = [
        {
          text: 'Facebook',
          id: 'fb',
          img: '/ng1/www/img/new/icons/socials/facebook.svg',
          show: true,
          click: function() {
            $scope.login_fb();
          }
        },
        {
          text: 'Google',
          id: 'google',
          img: '/ng1/www/img/new/icons/socials/google_plus.svg',
          show: true,
          click: function() {
            $scope.login_google();
          }
        },
        {
          text: 'Microsoft',
          id: 'microsoft',
          img: '/ng1/www/img/new/icons/socials/microsoft.svg',
          show: false,
          click: function() {
            $scope.login_microsoft();
          }
        }
      ];
    }
  ])

  .controller('LogoutCtrl', [
    '$location',
    '$scope',
    '$mdToast',
    'api',
    '$window',
    '$translate',
    function($location, $scope, $mdToast, api, $window, $translate) {
      $scope.logout = () => {
        api.logout();
        $mdToast.show(
          $mdToast
            .simple()
            .textContent($translate.instant(['toasts.logout'])['toasts.logout'])
            .position('bottom right')
            .hideDelay(6000)
        );
      };
    }
  ]);
